import { api_get } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { globalInvoiceStatusTypes } from "redux/reducers/globalInvoiceStatus/types";

const { HANDLE_GLOBAL_INVOICE_STATUS_INPUTS, GET_GLOBAL_INVOICE_STATUS } =
  globalInvoiceStatusTypes;

const qid = process.env.REACT_APP_QID_INVOICES;
// API PAY es el gateway (CRM-3109), igual que zip-download y el resto de
// invoicesTransferAction.js.
const mainUrl = `${process.env.REACT_APP_URL_PAY}/invoices`;

export const handleGlobalInvoiceStatusInputs = (key, value) => ({
  type: HANDLE_GLOBAL_INVOICE_STATUS_INPUTS,
  payload: { key, value },
});

export const getGlobalInvoiceStatus = (idStation, month, year) => {
  const url = `${mainUrl}/global-invoice-details?idStation=${idStation}&month=${month}&year=${year}&qid=${qid}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingGlobalInvoiceStatus"));
    try {
      const data = await api_get(url);
      dispatch({ type: GET_GLOBAL_INVOICE_STATUS, payload: data });
    } catch (error) {
      dispatch(setSnackbar(error));
    } finally {
      dispatch(stopRequestComp("loadingGlobalInvoiceStatus"));
    }
  };
};
